import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectedBill: '',
    insuranceType: '',
    paymentMethod: '',
    amount: '',
    questionsMap: [],
    questionsRules: {'expression': ''},
    display_kit_instruction: false,
    dl_or_ssn_required_by_client: false,
    allow_dl_or_ssn: true,
    logo: process.env.CLIENT_LOGO,
    paid: false,
    cashPayment: '',
    stripeToken: '',
    site: {
      code: '',
      name: '',
      address: ''
    },
    results: {
      user: {},
      site: {
        name: '',
        address: '',
        disclaimer: ''
      }
    },
    kit: {},
    adaptiveGridSystem: {
      mdColumnOrders: '',
      mdColumnKit: '',
      mdColumnResults: '',
      mdColumnDependents: '',
      mdColumnPersonalData: '',
      mdColumnAccount: ''
    },
    //eslint-disable-next-line
    dummyResult: '<style>\n  h4{\n    margin: 0;\n  }\n  \n  .dob{\n    font-size: 1.0em;\n  }\n  \n  .grid-container {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr); \/* or simply \"1fr 1fr;\" *\/\n  }\n  \n  .grid-container-results {\n    display: grid;\n    grid-template-columns: repeat(auto-fill,minmax(50%,1fr));\n    border-top: 1px solid black;\n    border-left: 1px solid black;\n    width: 50%;\n  }\n  \n  .center{\n    display: flex;\n    justify-content: center;\n  }\n  \n  .grid-item {\n    border-bottom: 1px solid black;\n    border-right: 1px solid black;\n  }\n  \n  .grid-float-right{\n    float: right;\n    text-align: right;\n    margin: 10px !important;\n  }\n  \n  .grid-float-left{\n    float: left;\n    text-align: left;\n    margin: 10px !important;\n  }\n  \n  .border-right-green{\n    border-right: 2px solid #7dc155;\n  }\n  \n  .hr-green{\n    background-color: #7dc155;\n    height: 5px;\n    width: 90%;\n  }\n\n  .result {\n    position: relative;\n  }\n\n  .download-final-report {\n      position: absolute !important;\n      bottom: -65px;\n      width: 230px;\n      right: 0;\n      color: #78bf54;\n      cursor: pointer;\n      border: 2px solid #77bf58;\n      border-radius: 10px;\n      z-index: 1;\n      font-size: 18px;\n      padding: 6px 12px;\n   }\n\n  @media all and (max-width: 1000px) {\n    .download-final-report {\n      width: 200px;\n      bottom: -139px;\n      right: -5px;\n      font-size: 16px;\n    }\n  }\n  \n  @media screen and (max-width: 767px) {\n    .grid-container-results {\n      width: 100%;\n    }\n  }\n  \n  <\/style>\n  \n  <h4>Name: mircea new_patient<h4>\n  <h5 class=\"dob\">DOB: 12\/22\/1990<\/h5>\n  <div>\n    <div class=\"grid-container\">\n      <div class=\"border-right-green\"><h6 class=\"grid-float-right\">Collection Date<\/h6><\/div>\n      <div><h6 class=\"grid-float-left\">08\/02\/2021<\/h6><\/div>\n      <div class=\"border-right-green\"><h6 class=\"grid-float-right\">Approved Date<\/h6><\/div>\n      <div><h6 class=\"grid-float-left\">08\/02\/2021<\/h6><\/div>\n      <div class=\"border-right-green\"><h6 class=\"grid-float-right\">Specimen ID<\/h6><\/div>\n      <div><h6 class=\"grid-float-left\">Rtest11172<\/h6><\/div>\n      <div class=\"border-right-green\"><h6 class=\"grid-float-right\">Laboratory Name<\/h6><\/div>\n      <div><h6 class=\"grid-float-left\">LIMSABC Lab<\/h6><\/div>\n      <div class=\"border-right-green\"><h6 class=\"grid-float-right\">CLIA#<\/h6><\/div>\n      <div><h6 class=\"grid-float-left\">0000000000<\/h6><\/div>\n      <div class=\"border-right-green\"><h6 class=\"grid-float-right\">Address<\/h6><\/div>\n      <div><h6 class=\"grid-float-left\">500 E Broward Blvd Suite 1710<\/h6><\/div>    \n    <\/div> \n  <div>\n  <hr class=\"hr-green\">\n  <h4>Test Results<\/h4>\n  <br>\n  <div class=\"center\">\n    <div class=\"grid-container-results\">\n              <div class=\"grid-item\"><h6 class=\"grid-float-right\">SARS-CoV-2 by PCR<\/h6><\/div>\n        <div class=\"grid-item\"><h6 class=\"grid-float-left\">0<\/h6><\/div>\n          <\/div>\n  <\/div>\n\n',
    ethnicity: '',
    race: '',
    gender: '',
    allows_client_bill: false,
    questions: [],
    requirements: {
      kit_number: '',
      ethnicity: '',
      gender: '',
      race: '',
      address: '',
      email: '',
      phone: '',
      passport: '',
      social_number: '',
      driver_license_number: '',
      first_name: '',
      last_name: '',
      date_of_birth: '',
      driver_license_image: '',
      insurance_card_image: '',
      middle_name: ''
    },
    insurance: '',
    lang: {
      value: 'EN'
    },
    translation: [],
    icdCodes: [],
    dataForInsurance: {
      first_name: '',
      last_name: '',
      dob: '',
      gender: '',
      address2: ''
    },
    medicalData: {
      first_name: '',
      last_name: '',
      phone: '',
      email: '',
      address: '',
      address2: ''
    },
    configs: {},
    accountResults: {},
    credentials: {
      email: ''
    },
    userData: {
      firstName: '',
      lastName: '',
      gender: '',
      dob_pretty: '',
      dob: '',
      dob_scanned: false,
      address_scanned: false,
      address: ''
    },
    dependentsData: [],
    currentData: {},
    insuranceData: {
      firstName: '',
      middleName: '',
      lastName: '',
      dob: '',
      dob_pretty: '',
      address: '',
      addressComponents: '',
      gender: ''
    },
    patientRegistrationData: {},
    registrationInsuranceData: {},
    insuranceValidator: false,
    medDataValidator: false,
    sitecode: '',
    allCallsDone: false,
    skip: false,
    accountsAllowed: true,
    dependentSelected: false,
    clientResults: [],
    clientLoggedKey: 1,
    firstRegistration: Boolean,
    restrict_email_to_domain: '',
    invalidSiteCode: false,
    international: false,
    consentSignature: '',
    relationship: '',
    confirmationNumberResultsUrl: '',
    geneticsComponentInsuranceData: {
      dob: '',
      dob_pretty: '',
      gender: ''
    },
    nameComponentInsuranceData: {
      firstName: '',
      lastName: ''
    },
    personIdentifierSection: {
      med_social_security_number: '',
      med_driver_license_number: ''
    },
    user: {
      address: '',
      addressComponents: '',
      firstName: '',
      lastName: '',
      dob: '',
      dob_pretty: '',
      guardian_dob: '',
      guardian_dob_pretty: '',
      guardianLastName: '',
      guardianFirstName: '',
      gender: '',
      race: '',
      ethnicity: '',
      driver_license_number: '',
      med_driver_license_number: '',
      social_security_number: '',
      med_social_security_number: '',
      passport: '',
      email: '',
      phone: '',
      middleName: ''
    },
    paymentProcess: false,
    allowSchedules: false,
    questionsErrorArray: [],
    crossAnswerPriceLabel: 'You do not qualify for'
  },
  getters: {},
  mutations: {
    setLang (state, lang) {
      this.state.lang = lang
    }
  },
  actions: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js